import { axiosInstance } from "./";

const addCategory = async (data) =>
  await axiosInstance.post("api/Category/Add", data);

const editCategory = async (data) =>
  await axiosInstance.put("/api/Category/Edit", data);

const approvedCategoriesList = async ({ params }) =>
  await axiosInstance.get("/api/Category/GetAll", {
    params,
    paramsSerializer: { indexes: null }
  });

const getCategoryDetails = async ({ id }) =>
  await axiosInstance.get(`/api/Category/GetById/${id}`);

const deleteCategory = async ({ data }) =>
  await axiosInstance.put("/api/Category/Delete", data);

const categorySubCategoriesList = async ({ params }) =>
  await axiosInstance.get(
    "/api/SubCategory/GetCategorySubCategories",
    {
      params,
      paramsSerializer: { indexes: null }
    }
  );

const requestsCategoriesList = async ({ params }) =>
  await axiosInstance.get("/api/Category/GetCategoryRequests", {
    params,
    paramsSerializer: { indexes: null }
  });

const requestsCategoriesDetails = async ({ id }) =>
  await axiosInstance.get(`/api/Category/ViewCategoryRequest/${id}`);

const rejectCategoryRequest = async ({ data }) =>
  await axiosInstance.put(`/api/Category/RejectRequest`, data);

const acceptCategoryRequest = async ({ id }) =>
  await axiosInstance.put(`/api/Category/AcceptRequest`, { Id: id });

export {
  addCategory,
  editCategory,
  approvedCategoriesList,
  getCategoryDetails,
  deleteCategory,
  categorySubCategoriesList,
  requestsCategoriesList,
  requestsCategoriesDetails,
  rejectCategoryRequest,
  acceptCategoryRequest
};
